import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { FP } from "./tokens";

// FinancePro top page header: bold module title + secondary subtitle (separated by a
// vertical bar) on the left; quick action icons + an optional primary CTA on the right.
export default function PageHeader({
  title,
  subtitle,
  cta,
  showQuickActions = true,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: "space-between",
        gap: 2,
        pl: { xs: 7.5, md: 3 },
        pr: { xs: 2, md: 3 },
        py: { xs: 1.75, md: 2 },
        bgcolor: FP.color.cardBg,
        borderBottom: `1px solid ${FP.color.border}`,
        position: "sticky",
        top: 0,
        zIndex: 10,
        backdropFilter: "saturate(180%) blur(6px)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.6, minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: { xs: "1.05rem", md: "1.15rem" },
            color: FP.color.textPrimary,
            letterSpacing: "-0.01em",
            lineHeight: 1.2,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <>
            <Box
              sx={{
                width: "1px",
                height: 22,
                bgcolor: FP.color.borderStrong,
                display: { xs: "none", sm: "block" },
              }}
            />
            <Typography
              sx={{
                fontSize: "0.78rem",
                fontWeight: 700,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: FP.color.textSecondary,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {subtitle}
            </Typography>
          </>
        ) : null}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexShrink: 0,
          alignSelf: { xs: "flex-end", md: "auto" },
        }}
      >
        {showQuickActions && (
          <>
            <Tooltip title="Notificaciones">
              <IconButton
                size="small"
                sx={{
                  color: FP.color.textSecondary,
                  border: `1px solid ${FP.color.border}`,
                  width: 36,
                  height: 36,
                  borderRadius: 1.4,
                  "&:hover": { bgcolor: FP.color.surfaceAlt, color: FP.color.navy },
                }}
              >
                <NotificationsNoneRoundedIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Ayuda">
              <IconButton
                size="small"
                sx={{
                  color: FP.color.textSecondary,
                  border: `1px solid ${FP.color.border}`,
                  width: 36,
                  height: 36,
                  borderRadius: 1.4,
                  "&:hover": { bgcolor: FP.color.surfaceAlt, color: FP.color.navy },
                }}
              >
                <HelpOutlineRoundedIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </>
        )}
        {cta ? <Box sx={{ ml: 0.5 }}>{cta}</Box> : null}
      </Box>
    </Box>
  );
}
